import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const Chronometer = ({ startDate }) => {
  const [timeElapsed, setTimeElapsed] = useState(0);

  useEffect(() => {
    const updateTimer = () => setTimeElapsed(Math.floor((new Date() - startDate) / 1000));

    const timerId = setInterval(updateTimer, 1000);

    return () => clearInterval(timerId);
  }, [startDate]);

  const formatTime = seconds => {
    const hours = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");
    return `${hours}:${minutes}:${secs}`;
  };

  return <div style={{ width: "70px" }}>{formatTime(timeElapsed)}</div>;
};

// Añadir validación de las propiedades
Chronometer.propTypes = {
  startDate: PropTypes.instanceOf(Date).isRequired,
};

export default Chronometer;
